export default `
{{#> page centered=1 scroll=1}}
  {{> network-error type="404" clarification="Не туда попали" }}
{{/page}}

`;
